import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const updateBudgetQuote: DocumentNode = gql`
  mutation updateBudgetQuote($budgetQuote: BudgetQuoteInput) {
    updateBudgetQuote(budgetQuoteInput: $budgetQuote) {
      id
      drawing {
        Floor {
          Size {
            XDim
            YDim
            TotalZDim
          }
          Tiers {
            Number
            Size {
              XDim
              YDim
              ZDim
            }
            Columns {
              Id
              Position {
                X
                Y
              }
              IsFlagpost
              IsGoalpost
              IsTagged
              Connections {
                Capplates {
                  Id
                }
                Beams {
                  Id
                }
              }
            }
            Beams {
              Id
              ConstructionType
              Start {
                X
                Y
              }
              End {
                X
                Y
              }
            }
            Joists {
              Start {
                X
                Y
              }
              End {
                X
                Y
              }
              Connections {
                Beams {
                  Id
                }
                Columns {
                  Id
                }
              }
            }
            Angles {
              CutoutDirection
              Position {
                X
                Y
              }
              Start {
                X
                Y
              }
              End {
                X
                Y
              }
            }
            Cutouts {
              Size {
                XDim
                YDim
              }
              Position {
                X
                Y
              }
            }
          }
          BayDirection
        }
      }
    }
  }
`;
